import {
  CURRENT_SONG_INDEX,
  CURRENT_SONG_LIST,
  LOADED,
  MAX_RANGE,
  NEW_SONG,
  ONCHANGE_LOADED,
  PLAY,
  RANGE,
  VOLUME,
} from "../types/player";

export const playNewSong = (song) => (dispatch) => {
  dispatch({ type: NEW_SONG, payload: song });
};

export const setmaxRange = (maxRange) => (dispatch) => {
  dispatch({ type: MAX_RANGE, payload: maxRange });
};
export const setrange = (range) => (dispatch) => {
  dispatch({ type: RANGE, payload: range });
};
export const setplay = (isPlay) => (dispatch) => {
  dispatch({ type: PLAY, payload: isPlay });
};
export const setloaded = (isLoaded) => (dispatch) => {
  dispatch({ type: LOADED, payload: isLoaded });
};

export const setonChangeLoaded = (isLoaded) => (dispatch) => {
  dispatch({ type: ONCHANGE_LOADED, payload: isLoaded });
};

export const setvolume = (volume) => (dispatch) => {
  dispatch({ type: VOLUME, payload: volume });
};

export const setcurrentSongIndex = (index) => (dispatch) => {
  dispatch({ type: CURRENT_SONG_INDEX, payload: index });
};

export const setcurrentSongList = (list) => (dispatch) => {
  dispatch({ type: CURRENT_SONG_LIST, payload: list });
};
